exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeleteModal-module__wrapper___1j2Mh{display:grid;gap:1rem}.DeleteModal-module__wrapper___1j2Mh h1{line-height:1}.DeleteModal-module__wrapper___1j2Mh p{justify-self:start!important}.DeleteModal-module__wrapper___1j2Mh a{color:#0827e9;cursor:pointer}.DeleteModal-module__wrapper___1j2Mh .DeleteModal-module__leave-groups___3a4Cr{display:grid;gap:.5rem}.DeleteModal-module__wrapper___1j2Mh .DeleteModal-module__body___2gk_K,.DeleteModal-module__wrapper___1j2Mh .DeleteModal-module__body___2gk_K .DeleteModal-module__user___3ik3k{display:grid;gap:1rem}.DeleteModal-module__wrapper___1j2Mh .DeleteModal-module__body___2gk_K .DeleteModal-module__user___3ik3k{grid-auto-flow:column;justify-content:start;align-items:center;margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "DeleteModal-module__wrapper___1j2Mh",
	"leave-groups": "DeleteModal-module__leave-groups___3a4Cr",
	"body": "DeleteModal-module__body___2gk_K",
	"user": "DeleteModal-module__user___3ik3k"
};